import { Injector } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { LocaleAwareBaseComponent } from './locale-aware-base.component';
import { DOCUMENT } from '@angular/platform-browser';

export abstract class SeoAwareBaseComponent extends LocaleAwareBaseComponent {
  static referrer_url: string;
  static utm_source: string;
  static utm_medium: string;
  static utm_campaign: string;

  protected meta: Meta;
  protected title: Title;

  public static getQueryParam(url: string, param: any): string {
    // https://dev.to/ganeshmani/how-to-get-query-string-parameters-in-javascript-2019-4dm2
    const href = url;
    // this expression is to get the query strings
    const reg = new RegExp( '[?&]' + param + '=([^&#]*)', 'i' );
    const queryString = reg.exec(href);
    return queryString ? queryString[1] : null;
  }

  constructor(
    public injector: Injector
  ) {
    super(injector);
    this.meta = this.injector.get(Meta);
    this.title = this.injector.get(Title);

    const document = this.injector.get(DOCUMENT);
    const window = this.injector.get('WINDOW');
    if (document && window) {
      if (window.location && window.location.href.includes('gclid=')) {
        SeoAwareBaseComponent.referrer_url = 'https://googleadservices.com';
      } else if (window.location && window.location.href.includes('fbclid=')) {
        SeoAwareBaseComponent.referrer_url = 'https://facebook.com';
      } else if (document.referrer && !document.referrer.startsWith(window.location.protocol + '//' + window.location.hostname)) {
        SeoAwareBaseComponent.referrer_url = document.referrer;
      }

      if (window.location && window.location.href) {
        const utm_source = SeoAwareBaseComponent.getQueryParam(window.location.href, 'utm_source');
        if (utm_source)
          SeoAwareBaseComponent.utm_source = utm_source;

        const utm_medium = SeoAwareBaseComponent.getQueryParam(window.location.href, 'utm_medium');
        if (utm_medium)
          SeoAwareBaseComponent.utm_medium = utm_medium;

        const utm_campaign = SeoAwareBaseComponent.getQueryParam(window.location.href, 'utm_campaign');
        if (utm_campaign)
          SeoAwareBaseComponent.utm_campaign = utm_campaign;
      }
    }

    if (!SeoAwareBaseComponent.referrer_url) {
      try {
        SeoAwareBaseComponent.referrer_url = localStorage.getItem('last_referrer_url');
      /* tslint:disable:no-empty */
      } catch (e) { }
      /* tslint:enable */
    } else {
      try {
        localStorage.setItem('last_referrer_url', SeoAwareBaseComponent.referrer_url);
      /* tslint:disable:no-empty */
      } catch (e) { }
      /* tslint:enable */
    }
  }

  public setTitle(messageToTranslate: string, additionalText?: string): void {
    const _title = (additionalText ? additionalText + ' - ' : '') + messageToTranslate;

    if (!this.isNullOrEmpty(_title)) {
      this.title.setTitle(_title);
      this.meta.removeTag('name=\'og:title\'');
      this.meta.removeTag('property=\'og:title\'');
      this.meta.removeTag('name=\'twitter:title\'');
      this.meta.removeTag('property=\'twitter:title\'');
      this.meta.addTags([
        { name: 'og:title', content: _title },
        { name: 'twitter:title', content: _title }
      ]);
    }
  }

  public setMetaDescription(description: string): void {
    this.meta.removeTag('name=\'description\'');
    this.meta.removeTag('property=\'description\'');
    this.meta.removeTag('name=\'og:description\'');
    this.meta.removeTag('property=\'og:description\'');
    this.meta.removeTag('name=\'twitter:description\'');
    this.meta.removeTag('property=\'twitter:description\'');
    this.meta.addTags([
      { name: 'description', content: description },
      { name: 'og:description', content: description },
      { name: 'twitter:description', content: description }
    ]);
  }

  private isNullOrEmpty(value: any): boolean {
    return value !== false && !value;
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/seo/seo-aware-base.component.ts